<template>
  <VDialogV3
    id="budget-price-card"
    position="right"

    width="600px"

    :entity="localBudgetPrice"
    :loading="localBudgetPrice === null"
    :context-menu="localBudgetPrice?.isExisting === true ? BudgetPricesService.contextMenu : null"
    :validate-on-mount="true"
    :submit-disabled="submitDisabled"

    @submit="onSubmit"
  >
    <template #badges>
      <VBadge v-if="localBudgetPrice.isDeleted">Удален</VBadge>
    </template>

    <section>
      <VSuggestionSelectV2
        v-model="localBudgetPrice.product"
        :data="({ pattern }) => ProductsService.search(pattern)"
        label="Продукт"
        placeholder="Введите наименование продукта"
        layout="vertical"
        required
        :disabled="localBudgetPrice.isDeleted"
      >
        <template #helper-text>
          Артикул:

          <template v-if="localBudgetPrice.product?.code">
            {{ localBudgetPrice.product.code }}
          </template>

          <template v-else>
            отсутствует
          </template>

        </template>
      </VSuggestionSelectV2>

      <!-- Сценарий 1: цену держит и сохраняет карточка, форма только правит переданный объект -->
      <BudgetPriceForm
        :budget-price="localBudgetPrice"
        required
        :disabled="localBudgetPrice.isDeleted"
      />
    </section>
  </VDialogV3>
</template>

<style lang="scss">
// локальный стиль, так BudgetPriceForm это section, и он находится в section
#budget-price-card #budget-price-form {
  > .mds-form-control:not(:first-child) {
    margin-top: 10px;
  }
}
</style>

<script lang="ts">
import Product from "@/domains/Products/Product";
import BudgetPrice from "@/domains/BudgetPrices/BudgetPrice";
import BudgetPricesService from "@/domains/BudgetPrices/BudgetPricesService";
import BudgetPriceForm from "@/domains/BudgetPrices/components/BudgetPriceCard/BudgetPriceForm.vue";
import ProductsService from "@/domains/Products/ProductsService";

export default defineComponent({
  name: "BudgetPriceCard",

  components: {
    BudgetPriceForm,
  },

  props: {
    product: {
      type: Object as PropType<Product>,
      default: null,
    },
    productId: {
      type: Number,
      default: null,
    },
  },

  setup() {
    return {
      ProductsService,
      BudgetPricesService
    }
  },

  data() {
    return {
      localBudgetPrice: null as unknown as BudgetPrice,
    }
  },

  async mounted() {
    await this.init();
  },

  computed: {
    submitDisabled(): boolean {
      return !this.localBudgetPrice?.product?.id || !this.localBudgetPrice?.price || !this.localBudgetPrice?.currency?.id;
    }
  },

  methods: {
    async init() {
      const localBudgetPriceProductId = this.product?.id ?? this.productId;

      if (localBudgetPriceProductId) {
        this.localBudgetPrice = await BudgetPricesService.get(localBudgetPriceProductId) ?? BudgetPrice.fromNew();
      }
      else {
        this.localBudgetPrice = BudgetPrice.fromNew();
      }
    },

    async onSubmit() {
      const success = await BudgetPricesService.upsert(this.localBudgetPrice);
      if (success) {
        this.$core.dialogs.BudgetPriceCard.resolve();
      }
    },
  },
})
</script>
